import { render, staticRenderFns } from "./thankYouComponent.vue?vue&type=template&id=3331ac3c"
import script from "./thankYouComponent.vue?vue&type=script&lang=js"
export * from "./thankYouComponent.vue?vue&type=script&lang=js"
import style0 from "./thankYouComponent.vue?vue&type=style&index=0&id=3331ac3c&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3331ac3c')) {
      api.createRecord('3331ac3c', component.options)
    } else {
      api.reload('3331ac3c', component.options)
    }
    module.hot.accept("./thankYouComponent.vue?vue&type=template&id=3331ac3c", function () {
      api.rerender('3331ac3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/thankYouComponent.vue"
export default component.exports